import TabPanel from "@mui/lab/TabPanel";
import { Grid, CircularProgress } from "@mui/material";
import { Chart } from "../../ingredients/Chart";

/**
 * @component Charts Overview Component
 * this component displays the charts in the overview page
 * 
 * @param {object} ingredientsMetrics
 * @param {object} user
 * @returns {JSX.Element} Charts Overview Component
 */
export default function ChartsOverview({ ingredientsMetrics, user }) {
  return (
    <TabPanel value="1">
      <Grid
        container
        spacing={2}
        columns={12}
        style={{ marginBottom: "30px" }}
      >
        {ingredientsMetrics ? (
          ingredientsMetrics?.map((metric) => (
            <Chart
              data={metric.metricsData}
              technofunctionality={metric.name}
              userId={user.userId}
              key={user.userId}
            />
          ))
        ) : (
          <CircularProgress
            style={{
              margin: "100px",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        )}
      </Grid>
    </TabPanel>
  );
}